export const environment = {
  production: false,
  api_base_url: 'https://api-staging.aptemassess.co.uk/api',
  instrumentation_key: '6fbab5f9-a521-48b2-a35f-241f2d88b8e4',
  debounceTime: 250,
};
